var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sw-grid-flex sw-grid-flex--dir-column" }, [
    _c(
      "div",
      {
        staticClass:
          "sw-grid-flex sw-grid-flex--wrap sw-grid-flex--align-center"
      },
      [
        _vm._l(_vm.manufacturers, function(item) {
          return _c(
            "div",
            {
              key: "manufacturer-" + item.id,
              staticClass: "sw-grid-flex__cell-1-4 sw--padding-2"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedManufacturers,
                    expression: "selectedManufacturers"
                  }
                ],
                attrs: {
                  disabled: !_vm.materialId,
                  type: "checkbox",
                  id: item.id
                },
                domProps: {
                  value: item.id,
                  checked: Array.isArray(_vm.selectedManufacturers)
                    ? _vm._i(_vm.selectedManufacturers, item.id) > -1
                    : _vm.selectedManufacturers
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.selectedManufacturers,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = item.id,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          (_vm.selectedManufacturers = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.selectedManufacturers = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.selectedManufacturers = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  class: !_vm.materialId ? "sw-dms--color-grey-64" : "",
                  attrs: { for: item.id }
                },
                [_vm._v(_vm._s(item.name) + "\n      ")]
              )
            ]
          )
        }),
        _vm._v(" "),
        _c("bottom-banner", {
          attrs: {
            "missing-info": _vm.missingInformation,
            "show-saved-message": _vm.showSavedMessage
          },
          on: { saved: _vm.saveManufacturers }
        }),
        _vm._v(" "),
        _vm.missingInformation.length <= 0
          ? _c(
              "div",
              { staticClass: "sw-grid-flex__cell-1-1 sw--padding-vert-2" },
              [
                _vm.allSelected
                  ? _c(
                      "button",
                      {
                        staticClass:
                          "sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer",
                        on: { click: _vm.unselectAll }
                      },
                      [_vm._v("\n        Unselect All\n      ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass:
                          "sw-dms-button sw-dms-button--big sw--float-right sw--cursor-pointer",
                        on: { click: _vm.selectAll }
                      },
                      [_vm._v("\n        Select All\n      ")]
                    )
              ]
            )
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }